import React, { useState, useEffect } from "react";
import Constants from "../../constants/Constants";
import VideoAnnoucment from "../VideoAnnoucment";
const Live = ({ site }) => {
  const [vidLength, setVidLength] = useState("");
  const [total, setTotal] = useState(0);
  const [describe, setDescribe] = useState("");
  const [hasError, setHasError] = useState("");
  const [timesuggestion, setTimesuggestion] = useState("");
  const [loading, setLoading] = useState(true);
  const [showRequestVideo, setShowRequestVideo] = useState(false);
  const [pending, setPending] = useState(false);
  const [pendingMsg, setPendingMsg] = useState(`Waiting On|To Accept`);
  const [paying, setPaying] = useState(false);
  //const polling = useRef(null);
  const hasPreviewVideo = [];
  useEffect(() => {
    // if (localStorage.getItem(`live-${site.id}`) === null) {
    //   localStorage.setItem(`live-${site.id}`, `watched`);
    //   setShowRequestVideo(true);
    // }
    fetch(`${Constants.API}has-live-req.php?siteid=${site.id}`, {
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.cstatus !== "none") {
          setDescribe(res.info.custom_req);
          setVidLength(parseInt(res.info.video_length));
          setPending(true);
          switch (res.cstatus) {
            case "accepted":
              setPendingMsg("|is ready to chat! Check your DM's");
              break;
            default:
              setPendingMsg(
                `Thank you.  Waiting while|accepts this 1on1 request.  We will reach out to you when it is accepted or declined.`
              );
          }
        }
        setLoading(false);
      });
  }, [site.id]);
  // const startPolling = (tok, newWindow) => {
  //   let evtSource = new EventSource(`${Constants.API}mjs.php?tok=${tok}`);
  //   polling.current = evtSource;

  //   evtSource.onopen = function() {
  //     console.log("Checking with the 7 about the new site.");
  //   };

  //   evtSource.onmessage = function(e) {
  //     if (e.data === "SUCCESS!") {
  //       evtSource.close();
  //       if (newWindow === null) {
  //         alert("Success, close the billing tab.");
  //       } else {
  //         newWindow.close();
  //       }
  //       //dev set state so that this window appears that we are waiting on mia.
  //     } else if (e.data === "STOP!") {
  //       if (newWindow !== null) {
  //         newWindow.close();
  //       }
  //       evtSource.close();
  //       //dev should display an error here or something...
  //     } else {
  //       console.log("...");
  //     }
  //   };

  //   evtSource.onerror = function() {
  //     evtSource.close();
  //     console.log("joined failed.");
  //   };
  // };

  const handleVidLength = (e) => {
    if (e.target.value === "") {
      setVidLength("");
      setTotal(0);
      return;
    }
    const long = parseInt(e.target.value);
    // if (long >= 4) {
    //   setTotal(long * 100);
    //   setVidLength(long);
    //   return;
    // }
    setVidLength(long);
    setTotal(300);
  };
  const handlePaying = () => {
    if (paying) return;
    if (pending) return;
    if (vidLength === "") {
      setHasError("please select how long you want your video to be.");
      return;
    }
    // if (total < 300) {
    //   setHasError("anything less then $300 is not accepted.");
    //   return;
    // }
    if (describe.length < 15) {
      setHasError(
        "please be a little more descriptive, greater then 15 characters at least!"
      );
      return;
    }
    if (timesuggestion.length < 4) {
      setHasError(
        "please give a little more info about date and times that work for you."
      );
      return;
    }
    if (timesuggestion.length > 75) {
      setHasError("please keep the date / times field below 75 characaters.");
      return;
    }
    if (describe.length > 3000) {
      setHasError(
        "alright a little TOO descriptive, less then 1000 characters please."
      );
      return;
    }

    // if (vidLength < 3) {
    //   setHasError("video length can be a minimum of 5 minutes.");
    //   return;
    // }
    setHasError("");
    setPaying(true);
    const formData = new FormData();
    formData.append("siteid", parseInt(site.id));
    formData.append("describe", describe);
    formData.append("timesuggestion", timesuggestion);
    formData.append("videolength", vidLength);

    fetch(`${Constants.API}request-live-event.php`, {
      method: "POST",
      credentials: "include",
      headers: {
        "X-XSRF-Header": Constants.XSRF,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((res) => {
        if ("error" in res) {
          setHasError(res.error);
          setPaying(false);
          return;
        }
        setPendingMsg(
          `Thank you.  Waiting while|accepts this 1on1 request.  We will reach out to you when it is accepted or declined.`
        );
        setPending(true);
        setPaying(false);
      });

    // setTimeout(() => {
    //   setPending(true);
    //   setPaying(false);
    // }, 5000);
  };
  if (loading) {
    return (
      <div className="customs-container">
        <div className="loadingChat">Loading...</div>
      </div>
    );
  }
  return (
    <div className="customs-container">
      {hasError !== "" && (
        <div className="custom-error">
          <h2>Error:</h2>
          {hasError}
        </div>
      )}

      <div className="custom-option">
        <h1 className="custom-h1">Describe what you'd like</h1>
        <textarea
          name="whatyouwant"
          id="whatyouwant"
          rows="5"
          className="custom-wywl"
          placeholder="let's talk about things"
          value={describe}
          onChange={(e) => setDescribe(e.target.value)}
        />
      </div>
      <div className="custom-option">
        <h1 className="custom-h1">Time / Dates</h1>
        <input
          type="text"
          className="custom-input"
          placeholder="3pm on fridays etc..."
          value={timesuggestion}
          onChange={(e) => setTimesuggestion(e.target.value)}
        />
      </div>
      <div className="custom-option inline">
        <h1 className="custom-h1">Length</h1>

        <select
          name="videolength"
          id="videoLength"
          value={vidLength}
          onChange={handleVidLength}
        >
          <option value="">select length</option>
          <option value="3">1 minutes</option>
          <option value="3">2 minutes</option>
          <option value="3">3 minutes</option>
          <option value="4">4 minutes</option>
          <option value="5">5+ minutes</option>
        </select>
      </div>

      <div className="custom-option center">
        <button
          className={paying ? "customs-pay active" : "customs-pay"}
          onClick={handlePaying}
        >
          {/* <span>Pay ${total}</span> */}
          <span>Request</span>
          <div
            className={
              paying ? "custom-spin-holder active" : "custom-spin-holder"
            }
            style={
              paying
                ? {
                    transform: `translate(${
                      total < 1000 ? `22` : `28`
                    }px, -50%)`,
                  }
                : null
            }
          >
            <div className="nk-spinner" />
          </div>
        </button>
      </div>
      {pending && (
        <div className="custom-pending">
          {pendingMsg.split("|")[0]}
          <span>
            <strong>{site.site_name.split(" ")[0]}</strong>{" "}
            {site.site_name
              .split(" ")
              .splice(1, 3)
              .join(" ")}
          </span>
          {pendingMsg.split("|")[1]}
        </div>
      )}
      {showRequestVideo && hasPreviewVideo.includes(parseInt(site.id)) && (
        <VideoAnnoucment
          setShowRequestVideo={setShowRequestVideo}
          url={`${site.site_url}-live`}
        />
      )}
    </div>
  );
};

export default Live;
